import { useState } from 'react';
import { createPortal } from 'react-dom';

import { useContextualSurface } from 'approot/shared/ally/contextual.hooks';
import ColourPicker from './colour-picker';
import * as Styled from './toolbar-item-pencil-colour.style';
import { ColourPickerPanel } from './colour-picker.style';
import ToolbarItem from './toolbar-item';
import { SUB_MENU_PORTAL_ID } from '../draw-canvas.constants';

type Props = {
  toolColour: string;
  hoverText: string;
  onSelect: (colour: string) => void;
};

const ToolbarItemPencilColour = ({
  toolColour,
  hoverText,
  onSelect,
}: Props) => {
  const [isActive, setIsActive] = useState<boolean>(false);

  const { styles, attributes, setReferenceElement, setPopperElement } =
    useContextualSurface(isActive, setIsActive, {
      offset: [0, 8],
      placement: 'left-start',
      strategy: 'fixed',
    });

  const portalContainer = document.getElementById(SUB_MENU_PORTAL_ID);

  const renderColourPicker = () => (
    <ColourPickerPanel
      ref={setPopperElement}
      role="dialog"
      tabIndex={-1}
      style={styles.popper}
      {...attributes.popper}
    >
      <ColourPicker
        currentColour={toolColour}
        onSelectColour={colour => {
          setIsActive(false);
          onSelect(colour);
        }}
      />
    </ColourPickerPanel>
  );

  return (
    <>
      <ToolbarItem hoverText={hoverText}>
        <Styled.ToolbarPencilColourButton
          type="button"
          ref={setReferenceElement}
          $colour={toolColour}
          $isActive={isActive}
          $size={20}
          onClick={() => setIsActive(!isActive)}
        />
      </ToolbarItem>
      {isActive &&
        (portalContainer
          ? createPortal(renderColourPicker(), portalContainer)
          : renderColourPicker())}
    </>
  );
};

export default ToolbarItemPencilColour;
